import BaseModel from './BaseModel';
import moment from 'moment';

export default class Tag extends BaseModel {
  constructor(data = {}) {
    super(Tag, data);
    this.id = data.id;
    this.label = data.label;
    this.createdAt = data.createdAt ? moment(data.createdAt) : null;
  }
}
